<template>
  <section class="py-8 mt-1 bg-white lg:py-24">
    <div class="max-w-5xl px-4 mx-auto">
      <!-- Title -->
      <div class="text-xl font-bold text-center text-black font-ww-bold sm:text-xl md:text-2xl xl:text-28" v-html="title"></div>

      <!-- Testimonials Grid -->
      <div class="grid grid-cols-12 mt-6 gap-y-4 md:mt-14 gap-x-5">
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          class="col-span-12 bg-white border border-black md:col-span-4"
        >
          <div class="px-4 py-6 space-y-2 md:space-y-4 md:py-10 lg:px-10 md:px-6">
            <nuxt-img
              class="mx-auto rounded-full"
              sizes="xs:135px sm:135px md:135px lg:135px xl:135px 2xl:135px"
              loading="lazy"
              format="webp"
              :src="testimonial.image"
              width="135"
              height="135"
              :alt="testimonial.alt"
            />

            <div>
              <nuxt-img
                class="mx-auto"
                sizes="xs:120px sm:120px md:120px lg:120px xl:120px 2xl:120px"
                loading="lazy"
                format="webp"
                :src="starsImageSrc"
                width="120"
                height="24"
                :alt="starsImageAlt"
              />
            </div>

            <div class="text-lg text-center text-black md:pt-3 xl:text-xl font-ww-bold">{{ testimonial.title }}</div>

            <div class="text-base text-center text-black xl:text-lg font-ww-light !leading-6">
              {{ testimonial.content }}
              <br /><br />
              - {{ testimonial.author }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// Props for dynamic content
const props = defineProps({
  title: {
    type: String,
    default: 'What Our Protected Members Are Saying:',
  },
  testimonials: {
    type: Array,
    default: () => [
      {
        image: '/assets/images/persons-1.png',
        alt: 'Testimonial 1 Image',
        title: '“Delicious”',
        content: 'This is the best coffee I have ever tasted. So delicious. This coffee lover is on a budget.',
        author: 'Shoshanda S. H.',
      },
      {
        image: '/assets/images/persons-2.png',
        alt: 'Testimonial 2 Image',
        title: '“Smooth coffee”',
        content:
          'This coffee is definitely the best tasting I have ever had and so very smooth. No acidic taste at all. It does not upset my stomach at all, like all the other coffees did.',
        author: 'Michael B.',
      },
      {
        image: '/assets/images/persons-3.png',
        alt: 'Testimonial 3 Image',
        title: '“Smooth and Delicious!”',
        content:
          'Wonderful, so gentle on my stomach. I can tell the difference between drinking this coffee versus other brands ❤️☕',
        author: 'Nicole F.',
      },
    ],
  },
  starsImageSrc: {
    type: String,
    default: '/assets/images/stars-black.svg',
  },
  starsImageAlt: {
    type: String,
    default: 'Rating Stars',
  },
});

// Builder.io configuration
defineBuilderComponent({
  friendlyName: 'TestimonialsCardGrid',
  inputs: [
    {
      name: 'title',
      type: 'richText',
      friendlyName: 'Section Title',
      defaultValue: 'What Our Protected Members Are Saying:',
    },
    {
      name: 'testimonials',
      type: 'list',
      friendlyName: 'Testimonials List',
      subFields: [
        {
          name: 'image',
          type: 'file',
          friendlyName: 'Testimonial Image',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        },
        {
          name: 'alt',
          type: 'text',
          friendlyName: 'Testimonial Image Alt Text',
        },
        {
          name: 'title',
          type: 'text',
          friendlyName: 'Testimonial Title',
        },
        {
          name: 'content',
          type: 'text',
          friendlyName: 'Testimonial Content',
        },
        {
          name: 'author',
          type: 'text',
          friendlyName: 'Testimonial Author',
        },
      ],
      defaultValue: [
        {
          image: '/assets/images/persons-1.png',
          alt: 'Testimonial 1 Image',
          title: '“Delicious”',
          content: 'This is the best coffee I have ever tasted. So delicious. This coffee lover is on a budget.',
          author: 'Shoshanda S. H.',
        },
        {
          image: '/assets/images/persons-2.png',
          alt: 'Testimonial 2 Image',
          title: '“Smooth coffee”',
          content:
            'This coffee is definitely the best tasting I have ever had and so very smooth. No acidic taste at all. It does not upset my stomach at all, like all the other coffees did.',
          author: 'Michael B.',
        },
        {
          image: '/assets/images/persons-3.png',
          alt: 'Testimonial 3 Image',
          title: '“Smooth and Delicious!”',
          content:
            'Wonderful, so gentle on my stomach. I can tell the difference between drinking this coffee versus other brands ❤️☕',
          author: 'Nicole F.',
        },
      ],
    },
    {
      name: 'starsImageSrc',
      type: 'file',
      friendlyName: 'Stars Image Source',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/stars-black.svg',
    },
    {
      name: 'starsImageAlt',
      type: 'text',
      friendlyName: 'Stars Image Alt Text',
      defaultValue: 'Rating Stars',
    },
  ],
});
</script>
